export { default } from './RecentSearches';
